// Phase 7 — resolve a Subtask row's display text in the active language.
//
// Auto-injected subtasks snapshot trilingual labels onto textEn/textFr/
// textNl at inject time. Ad-hoc user-typed subtasks leave those fields
// NULL and use the legacy single-string `text` column. Fallback chain:
//   textXX (active lang) → textEn → text → "".
// Reads window.__lxLang the same way pickEntryLabel does.

import type { Subtask } from "@shared/entities";

export function resolveSubtaskText(subtask: Subtask | null | undefined) {
  if (!subtask || typeof subtask !== "object") return "";
  const lang =
    (typeof window !== "undefined" && window.__lxLang) || "en";
  if (lang === "fr" && subtask.textFr) return subtask.textFr;
  if (lang === "nl" && subtask.textNl) return subtask.textNl;
  return subtask.textEn || subtask.text || "";
}

/**
 * BRIEF 118 §2 — a subtask's RUNG, from the column when it has one and from
 * `done` when it does not. The mirror of `server/src/lib/subtaskStatus.js`'s
 * `subtaskStatusOf`, and deliberately a second spelling rather than a shared
 * module: the server file is CommonJS inside `server/` and this side is the
 * bundle. What matters is that both resolve a NULL column the same way, which
 * is the only case where they can disagree — a row older than §2's backfill.
 */
export function subtaskStatusOf(
  row: { status?: string | null; done?: boolean } | null | undefined,
): string {
  if (!row) return "todo";
  const s = row.status;
  if (s === "todo" || s === "inprogress" || s === "completed") return s;
  return row.done ? "completed" : "todo";
}
